module.exports = __webpack_public_path__ + "img/1.578b62ff.png";